<script>
/**
 * Contexto de formulario para una celda del editor de grupo de la ficha. Le dice a los
 * campos de qué modelo es el registro y les da la fila (p. ej. el selector de gastos de un
 * pago lee la comisión bancaria de su fila). No tiene getValue/setValue: los campos que
 * los usan los saltean.
 */
export default {
  name: "ItemProfileRowContext",
  props: {
    modelName: { type: String, default: "" },
    lists: { type: Array, default: () => [] },
    row: { type: Object, default: null },
  },
  provide() {
    const ctx = this;
    return {
      formContext: {
        get selectedModel() {
          return ctx.modelName;
        },
        get lists() {
          return ctx.lists;
        },
        getState: () => ctx.row || {},
      },
    };
  },
  render(h) {
    const nodes = this.$scopedSlots.default ? this.$scopedSlots.default() : [];
    return nodes && nodes[0] ? nodes[0] : h();
  },
};
</script>
